<section>
  <div class="cg-inner-page-wrapper">
    <cigna-evernorth-logo></cigna-evernorth-logo>
  </div>
  <div class="footer-line"></div>
  <div class="cg-inner-page-wrapper">
    <div class="footer-links cg-margin-bottom-xl">
      <div class="row">
        <div class="col-md-4">
          <div class="cg-margin-bottom-xl">
            <a
              target="_blank"
              [href]="
                '/pdf/resourceLibrary/educationCenter/ProviderWebsiteOverview.pdf'
                  | resourceLink
                    : { targetApp: 'evernorth', type: 'file', secure: false }
                  | async
              "
              data-test-id="sitetour"
              [cignaTrackClicks]="[
                'trackEventOther',
                'Site tour',
                'ac22399',
                {
                  eVar120: 'footer-resource-links',
                  eVar119: 'US1881008'
                }
              ]"
            >
              Site tour
            </a>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-sm-4">
              <div class="cg-margin-bottom-xl">
                <a
                  target="resourcesWindow"
                  data-test-id="education-training"
                  rel="noopeneer"
                  [href]="
                    '/resourceLibrary/eCourses/eCourseBehavioralListing'
                      | resourceLink
                        : {
                            secure: isLoggedIn,
                            type: 'page',
                            targetApp: 'evernorth'
                          }
                      | async
                  "
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Behavioral Education and Training',
                    'ac22399',
                    {
                      eVar120: 'footer-resource-links',
                      eVar119: 'US1881008'
                    }
                  ]"
                  >Behavioral Education and Training</a
                >
              </div>
            </div>
            <div class="col-sm-8">
              <div class="cg-margin-bottom-xl">
                <a
                  target="_blank"
                  rel="noopeneer"
                  data-test-id="cigna-global-health"
                  href="https://provider.cignaenvoy.com/"
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Cigna Global Health Benefits',
                    'ac22399',
                    {
                      eVar120: 'footer-resource-links',
                      eVar119: 'US1881008'
                    }
                  ]"
                  >Cigna Global Health Benefits<cigna-icon
                    type="external-link"
                    class="cg-mat-icon-link-right green-icon"
                  ></cigna-icon
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="social-links">
      <a
        href="https://www.facebook.com/Evernorth/"
        target="_blank"
        data-test-id="facebook"
        rel="noopener noreferrer"
        aria-label="facebook"
        [cignaTrackClicks]="[
          'trackEventExit',
          'facebook',
          'ac22400',
          { eVar120: 'social-media-links', eVar119: 'US1881010' }
        ]"
      >
        <cigna-icon type="facebook-square"></cigna-icon>
      </a>
      <a
        href="https://www.twitter.com/evernorth"
        target="_blank"
        data-test-id="twitter"
        rel="noopener noreferrer"
        aria-label="twitter"
        [cignaTrackClicks]="[
          'trackEventExit',
          'twitter',
          'ac22400',
          { eVar120: 'social-media-links', eVar119: 'US1881010' }
        ]"
      >
        <cigna-icon type="twitter"></cigna-icon>
      </a>
      <a
        href="https://www.instagram.com/evernorth/"
        target="_blank"
        data-test-id="instagram"
        rel="noopener noreferrer"
        aria-label="instagram"
        [cignaTrackClicks]="[
          'trackEventExit',
          'instagram',
          'ac22400',
          { eVar120: 'social-media-links', eVar119: 'US1881010' }
        ]"
      >
        <cigna-icon type="instagram"></cigna-icon>
      </a>
      <a
        href="https://www.linkedin.com/company/evernorth/"
        target="_blank"
        data-test-id="linkedin"
        rel="noopener noreferrer"
        aria-label="linkedin"
        [cignaTrackClicks]="[
          'trackEventExit',
          'linkedin',
          'ac22400',
          { eVar120: 'social-media-links', eVar119: 'US1881010' }
        ]"
      >
        <cigna-icon type="linkedin-square"></cigna-icon>
      </a>
      <a
        href="https://www.youtube.com/evernorth"
        target="_blank"
        data-test-id="youtube"
        rel="noopener noreferrer"
        aria-label="youtube"
        [cignaTrackClicks]="[
          'trackEventExit',
          'youtube',
          'ac22400',
          { eVar120: 'social-media-links', eVar119: 'US1881010' }
        ]"
      >
        <cigna-icon type="youtube-play"></cigna-icon>
      </a>
    </div>
  </div>
  <div class="footer-line"></div>
  <div class="cg-inner-page-wrapper cg-margin-top-xxl disclaimers">
    <div>
      Availability of programs and services may vary by location and is subject
      to change.
    </div>
    <div class="cg-margin-top-lg">
      &copy; {{ currentYear }} Evernorth. All rights reserved.<br />
      All products and services are provided by or through operating
      subsidiaries or affiliates of Evernorth.
    </div>
    <div class="cg-margin-top-lg cg-margin-bottom-lg">
      <button
        cignaButton="link"
        data-test-id="need-help"
        style="padding: 0"
        (click)="openSiteHelpModal()"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Need Help?',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
      >
        Need Help?
      </button>
      <a
        target="_blank"
        data-test-id="terms-of-use"
        href="https://www.evernorth.com/terms-of-use"
        class="cg-margin-left-md"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Terms of use',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
        >Terms of Use</a
      >
      <a
        target="_blank"
        data-test-id="terms-of-use"
        [href]="
          '/resourceLibrary/provider/disclaimers/siteSpecificTerms'
            | resourceLink : { targetApp: 'evernorth', secure: false }
            | async
        "
        class="cg-margin-left-md"
        >Site Specific Terms</a
      >

      <a
        target="_blank"
        data-test-id="privacy"
        href="https://www.evernorth.com/privacy-policy"
        class="cg-margin-left-md"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Privacy',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
        >Privacy Notice</a
      >
      <a
        target="_blank"
        data-test-id="Nondiscrimination-Notice"
        href="https://www.evernorth.com/nondiscrimination"
        class="cg-margin-left-md"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Nondiscrimination Notice',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
        >Nondiscrimination Notice</a
      >
      <button
        *ngIf="hasOneTrustEnabled && !isLoggedIn"
        cignaButton="link"
        style="padding: 0"
        class="ot-sdk-show-settings cg-margin-left-md"
      >
        Cookies
      </button>
    </div>

    <!-- <div class="cg-margin-top-xl logo-row">
      <div class="cg-text-center flex-column cg-margin-right-xl">
        <a
          href="https://www.websecurity.symantec.com/ssl-certificate"
          title="Norton Security"
          target="_blank"
          rel="noopener noreferrer"
          [cignaTrackClicks]="[
            'trackEventExit',
            'Norton Secured',
            'ac22402',
            { eVar120: 'footer-icon-links', eVar119: 'US1882672' }
          ]"
        >
          <img
            [src]="'assets/images/footer/norton.png' | cdnPrefix"
            alt="Norton Secure"
            title="Norton Security"
          />


        <a
          href="https://www.websecurity.symantec.com/ssl-certificate"
          class="cg-margin-top-sm"
          target="_blank"
          data-test-id="ssl-certification"
          rel="noopener noreferrer"
          style="font-size: 12px"
          [cignaTrackClicks]="[
            'trackEventExit',
            'About SSL Certificates',
            'ac22402',
            { eVar120: 'footer-icon-links', eVar119: 'US1882672' }
          ]"
        >
          About SSL Certificates<cigna-icon
            type="external-link"
            class="cg-mat-icon-link-right green-icon"
          ></cigna-icon>
        </a>
      </div>
    </div> -->
    <div class="footer-disclaimer">
      <cigna-icon
        type="external-link"
        class="cg-mat-icon-link-left green-icon"
      ></cigna-icon>
      Selecting these links will take you away from provider.evernorth.com.
      Evernorth does not control the linked sites' content or links.
      <a
        class="lower-footer__link"
        data-test-id="details"
        href="https://www.evernorth.com/terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
        >Details</a
      >
    </div>
  </div>
</section>
